export default __webpack_public_path__ + "static/media/hero6.26f6b281.jpeg";